<template>
  <router-view />
</template>

<script>

export default {
  name: 'CarriageWrapper'
}
</script>
